import { request } from './api';

const queuesService = {
  // Buscar todas as filas
  async getQueues() {
    try {
      const response = await request('/api/queues');
      return response;
    } catch (error) {
      console.error('Erro ao buscar filas:', error);
      throw error;
    }
  },

  // Buscar fila por ID
  async getQueueById(id) {
    try {
      const response = await request(`/api/queues/${id}`);
      return response;
    } catch (error) {
      console.error('Erro ao buscar fila:', error);
      throw error;
    }
  },

  // Criar nova fila
  async createQueue(queueData) {
    try {
      const response = await request('/api/queues', {
        method: 'POST',
        body: queueData  // Remover JSON.stringify - a função request já faz isso
      });
      return response;
    } catch (error) {
      console.error('Erro ao criar fila:', error);
      throw error;
    }
  },

  // Atualizar fila
  async updateQueue(id, queueData) {
    try {
      const response = await request(`/api/queues/${id}`, {
        method: 'PUT',
        body: queueData  // Remover JSON.stringify - a função request já faz isso
      });
      return response;
    } catch (error) {
      console.error('Erro ao atualizar fila:', error);
      throw error;
    }
  },

  // Deletar fila
  async deleteQueue(id) {
    try {
      const response = await request(`/api/queues/${id}`, {
        method: 'DELETE'
      });
      return response;
    } catch (error) {
      console.error('Erro ao deletar fila:', error);
      throw error;
    }
  }
};

export default queuesService;